import { Video, FileText, FlaskConical, MapPin } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";

const FEATURES = [
  { icon: MapPin, label: "India" },
  { icon: Video, label: "Secure video consultation" },
  { icon: FileText, label: "Digital health profile" },
  { icon: FlaskConical, label: "Laboratory report review" },
];

export const VirtualCare = () => (
  <section className="bg-ivory grain relative" data-testid="virtual-care-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20 lg:py-32 grid grid-cols-1 lg:grid-cols-12 gap-14 items-center">
      <div className="lg:col-span-7">
        <Reveal>
          <Eyebrow>08 · Virtual care</Eyebrow>
          <h2 className="mt-6 font-serif font-medium text-forest text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
            Healthcare without geographical boundaries.
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-7 text-inkmuted leading-relaxed max-w-xl">
            Consult from wherever you are. InSight Metabolics provides virtual consultations for patients
            across India.
          </p>
        </Reveal>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-xl">
          {FEATURES.map((f, i) => (
            <Reveal key={f.label} delay={0.06 * i}>
              <div className="flex items-center gap-4 bg-white border border-line px-5 py-4">
                <f.icon size={18} className="text-gold shrink-0" strokeWidth={1.5} />
                <span className="text-sm font-medium text-ink">{f.label}</span>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.25}>
          <p className="mt-10 text-xs text-inkmuted/80 leading-relaxed max-w-xl border-l-2 border-gold/60 pl-5">
            Virtual medical care is subject to applicable laws, licensing requirements and prescribing regulations
            in the patient&rsquo;s location. Availability of consultation, diagnosis, prescriptions and
            investigations may therefore vary by country.
          </p>
        </Reveal>
      </div>
      <div className="lg:col-span-5">
        <Reveal delay={0.15}>
          <div className="relative">
            <div className="absolute -inset-3 border border-gold/50 pointer-events-none" aria-hidden="true" />
            <img
              src="/assets/virtual-care.jpg"
              alt="Sunlight filtering through a quiet forest — care that meets you wherever you are"
              className="w-full h-[380px] sm:h-[460px] object-cover"
              loading="lazy"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
